/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UtilityTypeEnum {
    WATER = 'Water',
    GAS = 'Gas',
    ELECTRIC = 'Electric',
    FIRE_LINE = 'FireLine',
    SPRINKLER = 'Sprinkler',
}